export default "__VITE_PUBLIC_ASSET__236631b1__"